var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _ellipse2, _path50, _path51, _path52, _path53, _ellipse3, _path54, _path55, _path56, _path57, _ellipse4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonster2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 185,
    viewBox: "0 0 187 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.3721,
    cy: 162.59,
    rx: 67.3875,
    ry: 15.7292,
    fill: "url(#paint0_radial_14011_169616)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.467 103.488C169.467 104.735 168.456 105.748 167.207 105.748C165.96 105.748 164.946 104.735 164.946 103.488C164.946 102.24 165.96 101.228 167.207 101.228C168.456 101.228 169.467 102.24 169.467 103.488Z",
    fill: "#2E2A49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.654 100.374C172.654 101.621 171.643 102.633 170.393 102.633C169.146 102.633 168.134 101.621 168.134 100.374C168.134 99.1262 169.146 98.1131 170.393 98.1131C171.643 98.1131 172.654 99.1262 172.654 100.374Z",
    fill: "#2E2A49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.788 96.0696C173.788 97.3172 172.777 98.3291 171.528 98.3291C170.28 98.3291 169.27 97.3172 169.27 96.0696C169.27 94.822 170.28 93.8089 171.528 93.8089C172.777 93.8089 173.788 94.822 173.788 96.0696Z",
    fill: "#2E2A49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.151 100.787C167.586 104.728 162.31 105.844 158.369 103.279C154.427 100.714 142.168 88.1906 144.734 84.2484C147.298 80.3066 163.717 86.4401 167.658 89.0059C171.599 91.5716 172.715 96.8455 170.151 100.787Z",
    fill: "#1496DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.842 99.0579C165.762 102.252 161.487 103.157 158.291 101.08C155.095 98.9994 145.162 88.8482 147.239 85.6536C149.319 82.4592 162.625 87.432 165.822 89.5105C169.014 91.5884 169.92 95.864 167.842 99.0579Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.067 126.274C167.067 127.522 166.056 128.535 164.808 128.535C163.56 128.535 162.547 127.522 162.547 126.274C162.547 125.026 163.56 124.014 164.808 124.014C166.056 124.014 167.067 125.026 167.067 126.274Z",
    fill: "#2E2A49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.254 123.16C170.254 124.408 169.241 125.42 167.993 125.42C166.744 125.42 165.733 124.408 165.733 123.16C165.733 121.913 166.744 120.9 167.993 120.9C169.241 120.9 170.254 121.913 170.254 123.16Z",
    fill: "#2E2A49"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.389 118.856C171.389 120.105 170.376 121.117 169.129 121.117C167.879 121.117 166.868 120.105 166.868 118.856C166.868 117.608 167.879 116.595 169.129 116.595C170.376 116.595 171.389 117.608 171.389 118.856Z",
    fill: "#2E2A49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.75 123.574C165.186 127.514 159.91 128.63 155.966 126.065C152.025 123.501 139.768 110.977 142.333 107.035C144.897 103.093 161.314 109.228 165.256 111.793C169.199 114.358 170.315 119.634 167.75 123.574Z",
    fill: "#1496DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.44 121.845C163.362 125.039 159.086 125.944 155.89 123.865C152.696 121.787 142.761 111.634 144.841 108.44C146.917 105.246 160.225 110.217 163.419 112.296C166.613 114.374 167.518 118.649 165.44 121.845Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0593 103.488C19.0593 104.735 20.0713 105.748 21.3202 105.748C22.5691 105.748 23.5799 104.735 23.5799 103.488C23.5799 102.24 22.5691 101.228 21.3202 101.228C20.0713 101.228 19.0593 102.24 19.0593 103.488Z",
    fill: "#2E2A49"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8726 100.374C15.8726 101.621 16.8857 102.633 18.1334 102.633C19.3823 102.633 20.3931 101.621 20.3931 100.374C20.3931 99.1261 19.3823 98.113 18.1334 98.113C16.8857 98.113 15.8726 99.1261 15.8726 100.374Z",
    fill: "#2E2A49"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7385 96.0695C14.7385 97.3171 15.7481 98.329 16.997 98.329C18.2459 98.329 19.2567 97.3171 19.2567 96.0695C19.2567 94.8219 18.2459 93.8088 16.997 93.8088C15.7481 93.8088 14.7385 94.8219 14.7385 96.0695Z",
    fill: "#2E2A49"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3749 100.787C20.9403 104.727 26.2169 105.844 30.1578 103.278C34.0999 100.714 46.3575 88.1904 43.7919 84.2482C41.2279 80.3064 24.8108 86.4412 20.8693 89.006C16.9278 91.5708 15.8109 96.8453 18.3749 100.787Z",
    fill: "#1496DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.6857 99.0579C22.7658 102.252 27.0405 103.157 30.2359 101.08C33.4304 99.0004 43.3671 88.8479 41.287 85.6537C39.2085 82.4597 25.9021 87.4319 22.7063 89.5098C19.5127 91.5891 18.6072 95.864 20.6857 99.0579Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4591 126.274C21.4591 127.522 22.4722 128.535 23.7188 128.535C24.9677 128.535 25.9797 127.522 25.9797 126.274C25.9797 125.027 24.9677 124.015 23.7188 124.015C22.4722 124.015 21.4591 125.027 21.4591 126.274Z",
    fill: "#2E2A49"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2753 123.16C18.2753 124.408 19.2872 125.42 20.5361 125.42C21.7838 125.42 22.7935 124.408 22.7935 123.16C22.7935 121.912 21.7838 120.899 20.5361 120.899C19.2872 120.899 18.2753 121.912 18.2753 123.16Z",
    fill: "#2E2A49"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1377 118.856C17.1377 120.104 18.1485 121.115 19.3974 121.115C20.6451 121.115 21.6582 120.104 21.6582 118.856C21.6582 117.608 20.6451 116.595 19.3974 116.595C18.1485 116.595 17.1377 117.608 17.1377 118.856Z",
    fill: "#2E2A49"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7766 123.573C23.3394 127.513 28.616 128.63 32.5585 126.065C36.5006 123.501 48.7579 110.977 46.1922 107.035C43.6281 103.093 27.2121 109.227 23.2697 111.793C19.3256 114.358 18.2105 119.633 20.7766 123.573Z",
    fill: "#1496DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.0882 121.845C25.1659 125.039 29.4423 125.944 32.6363 123.865C35.8313 121.786 45.768 111.634 43.6877 108.44C41.609 105.246 28.3032 110.217 25.1091 112.296C21.9125 114.375 21.0089 118.65 23.0882 121.845Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M148.389 145.402C149.326 151.841 144.865 157.821 138.426 158.757C131.985 159.695 111.343 157.37 110.406 150.931C109.468 144.495 128.592 136.379 135.034 135.441C141.472 134.506 147.453 138.965 148.389 145.402Z",
    fill: "#1496DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.91 144.636C146.699 150.057 142.943 155.089 137.522 155.879C132.105 156.669 114.726 154.711 113.934 149.29C113.149 143.872 129.249 137.041 134.668 136.252C140.088 135.464 145.118 139.216 145.91 144.636Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.669 153.983C123.36 150.377 132.258 143.965 139.13 135.547C137.839 135.289 136.486 135.24 135.112 135.44C134.941 135.466 134.761 135.496 134.573 135.53C128.484 143.127 120.466 148.833 110.759 151.842C111.118 152.624 111.78 153.337 112.669 153.983Z",
    fill: "#0076AA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3241 145.403C39.3868 151.842 43.8476 157.822 50.2859 158.758C56.7251 159.695 77.3698 157.37 78.3083 150.932C79.2466 144.494 60.1195 136.379 53.6802 135.441C47.2431 134.506 41.2626 138.965 40.3241 145.403Z",
    fill: "#1496DB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.8053 144.637C42.016 150.058 45.7691 155.09 51.1907 155.879C56.6099 156.669 73.9893 154.712 74.7786 149.291C75.5665 143.872 59.4677 137.041 54.0483 136.252C48.6277 135.464 43.5945 139.217 42.8053 144.637Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0429 153.983C65.3525 150.377 56.4561 143.965 49.5848 135.547C50.8734 135.289 52.2274 135.24 53.6023 135.44C53.7727 135.466 53.9525 135.496 54.1392 135.53C60.2308 143.127 68.246 148.833 77.9559 151.842C77.5964 152.624 76.9323 153.337 76.0429 153.983Z",
    fill: "#0076AA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M157.452 35.9692C162.194 43.1236 160.239 52.7688 153.083 57.5123C145.929 62.2538 123.931 68.487 119.189 61.3316C114.443 54.1797 128.751 36.3463 135.906 31.605C143.063 26.8599 152.707 28.8157 157.452 35.9692Z",
    fill: "#1496DB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.303 41.7278C158.397 47.2789 156.409 54.2886 150.854 57.3842C145.305 60.4792 136.341 61.1981 133.246 55.6477C130.149 50.0949 134.094 40.3786 139.645 37.2813C145.198 34.1863 152.206 36.177 155.303 41.7278Z",
    fill: "#0076AA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M147.116 48.138C148.936 51.3135 146.839 55.9317 142.433 58.455C138.031 60.9776 132.988 60.4495 131.168 57.2766C129.349 54.1005 131.443 49.4825 135.847 46.9588C140.252 44.4371 145.295 44.9641 147.116 48.138Z",
    fill: "#2E2A49"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4231 35.9691C26.6797 43.1237 28.6341 52.769 35.7909 57.5117C42.9442 62.2534 64.9415 68.4865 69.6839 61.3313C74.428 54.1799 60.1206 36.346 52.9657 31.6046C45.8111 26.8606 36.166 28.8154 31.4231 35.9691Z",
    fill: "#1496DB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5692 41.7276C30.4737 47.2791 32.4644 54.289 38.0171 57.3832C43.5675 60.4788 52.5311 61.1975 55.6259 55.6469C58.7214 50.0954 54.7779 40.3779 49.2272 37.2807C43.6745 34.1865 36.664 36.177 33.5692 41.7276Z",
    fill: "#0076AA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.757 48.1376C39.9382 51.3137 42.0339 55.9312 46.4382 58.4548C50.8415 60.9778 55.8864 60.4492 57.7052 57.2757C59.525 54.1001 57.4293 49.4826 53.0266 46.9585C48.6212 44.437 43.5784 44.9642 41.757 48.1376Z",
    fill: "#2E2A49"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M148.101 92.9956C148.101 126.819 128.088 154.238 94.2629 154.238C60.4364 154.238 40.4236 126.819 40.4236 92.9956C40.4236 59.172 60.4364 31.7522 94.2629 31.7522C128.088 31.7522 148.101 59.172 148.101 92.9956Z",
    fill: "#1496DB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.211 88.7586C141.211 118.253 123.759 142.163 94.2632 142.163C64.767 142.163 47.3162 118.253 47.3162 88.7586C47.3162 59.2638 64.767 35.3558 94.2632 35.3558C123.759 35.3558 141.211 59.2638 141.211 88.7586Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M143.758 87.1314C144.614 84.0198 145.066 80.7778 145.066 77.4465C145.066 53.8835 122.431 34.782 94.5088 34.782C66.5867 34.782 43.9514 53.8835 43.9514 77.4465C43.9514 81.2511 44.5415 84.9394 45.6488 88.4497C44.8023 91.3292 44.355 94.3284 44.355 97.4097C44.355 119.329 66.9904 137.098 94.9124 137.098C122.834 137.098 145.47 119.329 145.47 97.4097C145.47 93.8551 144.875 90.4096 143.758 87.1314Z",
    fill: "url(#paint1_radial_14011_169616)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M117.348 89.3007C117.348 86.3199 114.804 83.6228 110.691 81.6702C110.694 81.6387 110.701 81.6072 110.706 81.5757C106.588 79.615 100.894 78.4023 94.6043 78.4023C88.4228 78.4023 82.8168 79.5741 78.7188 81.4741C78.7234 81.508 78.7293 81.5418 78.7351 81.5757C78.7293 81.578 78.7234 81.5803 78.7188 81.5827C78.7188 81.5827 78.7188 81.585 78.7199 81.5862C74.5029 83.5457 71.8837 86.2779 71.8837 89.3007C71.8837 95.2599 82.0605 100.093 94.6148 100.093H94.7304C100.987 100.093 106.653 98.8919 110.762 96.951C110.758 96.9358 110.75 96.9207 110.744 96.9055C114.826 94.9541 117.348 92.2674 117.348 89.3007Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.346 88.765C117.346 94.7304 107.169 99.5663 94.6158 99.5663C82.0622 99.5663 71.8855 94.7304 71.8855 88.765C71.8855 82.7996 82.0622 77.9636 94.6158 77.9636C107.169 77.9636 117.346 82.7996 117.346 88.765Z",
    fill: "url(#paint2_linear_14011_169616)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7036 96.4091C82.8091 98.3503 88.4727 99.5497 94.7299 99.5497C100.987 99.5497 106.651 98.3503 110.756 96.4091C108.209 90.0659 101.989 85.5774 94.7299 85.5774C87.4711 85.5774 81.251 90.0659 78.7036 96.4091Z",
    fill: "url(#paint3_radial_14011_169616)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.001 90.6438C102.001 92.8834 98.5366 94.6982 94.2635 94.6982C89.9892 94.6982 86.5238 92.8834 86.5238 90.6438C86.5238 88.4041 89.9892 86.5893 94.2635 86.5893C98.5366 86.5893 102.001 88.4041 102.001 90.6438Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6041 77.9668C88.4238 77.9668 82.8166 79.1386 78.7197 81.0386C78.9858 83.2362 80.8569 84.939 83.1247 84.939H106.312C108.546 84.939 110.395 83.2887 110.706 81.1401C106.589 79.1806 100.895 77.9668 94.6041 77.9668Z",
    fill: "#EDDD9A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.612 77.9666C88.895 77.9666 83.7115 78.7625 79.9216 80.5202C80.1679 82.5521 81.8907 84.1673 83.9893 84.1673H105.433C107.5 84.1673 109.215 82.5941 109.501 80.6077C105.696 78.794 100.429 77.9666 94.612 77.9666Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6041 79.5773C100.648 79.5773 106.136 80.6989 110.207 82.5243C110.455 82.0703 110.629 81.5672 110.706 81.0327C106.589 79.0732 100.895 77.8594 94.6041 77.8594C88.4226 77.8594 82.8166 79.0311 78.7197 80.9323C78.7839 81.4727 78.9473 81.9816 79.1878 82.4437C83.2403 80.6651 88.6514 79.5773 94.6041 79.5773Z",
    fill: "#E66D28"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8605 64.8994C84.8605 71.965 79.1319 77.6919 72.0657 77.6919C64.9994 77.6919 59.272 71.965 59.272 64.8994C59.272 57.8338 64.9994 52.1057 72.0657 52.1057C79.1319 52.1057 84.8605 57.8338 84.8605 64.8994Z",
    fill: "#1496DB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M129.961 65.2664C129.961 72.3332 124.232 78.0613 117.165 78.0613C110.098 78.0613 104.372 72.3332 104.372 65.2664C104.372 58.2008 110.098 52.4739 117.165 52.4739C124.232 52.4739 129.961 58.2008 129.961 65.2664Z",
    fill: "#1496DB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M110.113 52.0686C110.113 60.5721 103.218 67.4673 94.7103 67.4673C86.2073 67.4673 79.3127 60.5721 79.3127 52.0686C79.3127 43.5652 86.2073 36.67 94.7103 36.67C103.218 36.67 110.113 43.5652 110.113 52.0686Z",
    fill: "#1496DB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M83.134 64.8987C83.134 71.0097 78.1793 75.9663 72.0655 75.9663C65.9529 75.9663 60.9993 71.0097 60.9993 64.8987C60.9993 58.7866 65.9529 53.8335 72.0655 53.8335C78.1793 53.8335 83.134 58.7866 83.134 64.8987Z",
    fill: "#1496DB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4175 64.8986C82.4175 70.6148 77.7833 75.2487 72.0666 75.2487C66.35 75.2487 61.7157 70.6148 61.7157 64.8986C61.7157 59.1825 66.35 54.5486 72.0666 54.5486C77.7833 54.5486 82.4175 59.1825 82.4175 64.8986Z",
    fill: "url(#paint4_radial_14011_169616)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6317 64.9008C77.6317 67.9756 75.1389 70.4681 72.0639 70.4681C68.9889 70.4681 66.4961 67.9756 66.4961 64.9008C66.4961 61.8261 68.9889 59.3335 72.0639 59.3335C75.1389 59.3335 77.6317 61.8261 77.6317 64.9008Z",
    fill: "url(#paint5_radial_14011_169616)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M74.671 64.8987C74.671 66.3366 73.5038 67.5037 72.0659 67.5037C70.6267 67.5037 69.4607 66.3366 69.4607 64.8987C69.4607 63.4608 70.6267 62.2937 72.0659 62.2937C73.5038 62.2937 74.671 63.4608 74.671 64.8987Z",
    fill: "#2E2A49"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.0427,
    cy: 62.516,
    rx: 3.09984,
    ry: 2.38051,
    fill: "url(#paint6_linear_14011_169616)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M128.233 65.2685C128.233 71.3794 123.278 76.3337 117.166 76.3337C111.053 76.3337 106.098 71.3794 106.098 65.2685C106.098 59.1564 111.053 54.2009 117.166 54.2009C123.278 54.2009 128.233 59.1564 128.233 65.2685Z",
    fill: "#1496DB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.516 65.2687C127.516 70.9847 122.882 75.6184 117.165 75.6184C111.449 75.6184 106.815 70.9847 106.815 65.2687C106.815 59.5527 111.449 54.9189 117.165 54.9189C122.882 54.9189 127.516 59.5527 127.516 65.2687Z",
    fill: "url(#paint7_radial_14011_169616)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.734 65.2683C122.734 68.3433 120.241 70.8362 117.166 70.8362C114.09 70.8362 111.597 68.3433 111.597 65.2683C111.597 62.1933 114.09 59.7004 117.166 59.7004C120.241 59.7004 122.734 62.1933 122.734 65.2683Z",
    fill: "url(#paint8_radial_14011_169616)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M119.769 65.268C119.769 66.7059 118.604 67.8718 117.166 67.8718C115.727 67.8718 114.561 66.7059 114.561 65.268C114.561 63.8302 115.727 62.6642 117.166 62.6642C118.604 62.6642 119.769 63.8302 119.769 65.268Z",
    fill: "#2E2A49"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.153,
    cy: 62.516,
    rx: 3.09984,
    ry: 2.38051,
    fill: "url(#paint9_linear_14011_169616)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M108.351 52.0681C108.351 59.653 102.2 65.8013 94.6167 65.8013C87.0287 65.8013 80.8799 59.653 80.8799 52.0681C80.8799 44.4831 87.0287 38.3348 94.6167 38.3348C102.2 38.3348 108.351 44.4831 108.351 52.0681Z",
    fill: "#1496DB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.462 52.0682C107.462 59.1621 101.71 64.9128 94.6158 64.9128C87.5214 64.9128 81.7701 59.1621 81.7701 52.0682C81.7701 44.9744 87.5214 39.2236 94.6158 39.2236C101.71 39.2236 107.462 44.9744 107.462 52.0682Z",
    fill: "url(#paint10_radial_14011_169616)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.526 52.0677C101.526 55.884 98.4321 58.9777 94.6154 58.9777C90.7988 58.9777 87.7048 55.884 87.7048 52.0677C87.7048 48.2514 90.7988 45.1577 94.6154 45.1577C98.4321 45.1577 101.526 48.2514 101.526 52.0677Z",
    fill: "url(#paint11_radial_14011_169616)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8491 52.0681C97.8491 53.8526 96.4018 55.2998 94.6172 55.2998C92.8302 55.2998 91.384 53.8526 91.384 52.0681C91.384 50.2836 92.8302 48.8353 94.6172 48.8353C96.4018 48.8353 97.8491 50.2836 97.8491 52.0681Z",
    fill: "#2E2A49"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.6192,
    cy: 48.6536,
    rx: 3.84661,
    ry: 2.95659,
    fill: "url(#paint12_linear_14011_169616)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.3721 162.59) rotate(90) scale(15.7292 67.3875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.7106 80.7565) rotate(90) scale(61.754 73.6541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224916,
    stopColor: "#E4E4E4",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521135,
    stopColor: "#C530B6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14011_169616",
    x1: 71.7131,
    y1: 99.49,
    x2: 71.7712,
    y2: 77.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.7297 92.5638) scale(12.366 5.39057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1622"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0663 64.899) scale(10.3509 10.35)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0651 64.8996) scale(5.56779 5.56732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14011_169616",
    x1: 72.0484,
    y1: 60.1355,
    x2: 72.0484,
    y2: 62.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.166 65.2682) scale(10.3507 10.3497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.166 65.2682) scale(5.56834 5.56786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_169616",
    x1: 117.159,
    y1: 60.1355,
    x2: 117.159,
    y2: 62.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.6163 52.0678) scale(12.8457 12.8446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_14011_169616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.6153 52.0678) scale(6.9106 6.91)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14011_169616",
    x1: 94.6262,
    y1: 45.697,
    x2: 94.6262,
    y2: 48.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster2);
export default __webpack_public_path__ + "static/media/Monster2.1a19564748f60b196adb1d4172ce9447.svg";
export { ForwardRef as ReactComponent };